import WebLayout from './UrlImageLayout.web';
import MobileLayout from './UrlImageLayout.mobile';
import { isReactNative } from 'ui-builder';

export default isReactNative() ? MobileLayout : WebLayout;

